<app-header-one [class]="'header-gym'"></app-header-one>
<!--app-subheader [isCheck]="true" [statusCheck]="cartData.order.status" [title]="getTitle()" [subTitle]="getSubTitle()"></app-subheader-->
<!--app-subheader [title]="getTitle()"></app-subheader-->
<ng-container *ngIf="cartData && cartData.order">
  <section class="section-b-space checkpay-page pt-0 mb-5">
    <div class="container">
      <h2 class="my-5 d-none d-md-block">{{getShortTitle()}}</h2>
      <div class="mt-4 d-block d-md-none"><app-navigation-bar [page]="getShortTitle()"></app-navigation-bar></div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6">
          <h1 class="mb-5" [innerHTML]="getTitle()"></h1>
          <button class="mega-button d-none d-md-block" (click)="trackOrder()" *ngIf="orderCompleted()">
            Monitora il tuo ordine
            <img src="assets/icons/freccia.svg">
          </button>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 rest-info-col" *ngIf="!cartData.order.ismultiorder">
          <div class="card">
            <div class="card-body" [ngStyle]="{'background-image': 'url('+ appInfo.ASSETS_URL + cartData.order.rest_mediaheader.filename + ')'}"></div>
          </div>
          <h5 class="my-3">{{cartData.order.restaurant}}</h5>
          <button class="mega-button d-block d-md-none mt-5" (click)="trackOrder()" *ngIf="orderCompleted()">
            Monitora il tuo ordine
            <img src="assets/icons/freccia.svg">
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="section-b-space tracking-section pt-0 mb-5" *ngIf="!cartData.order.ismultiorder">
    <div class="container">
      <div class="collection-collapse-block" [class.open]="collapseOrder">
        <div class="collection-collapse-block-content">
          <div class="row tracking-row">
            <div class="col-md-3 col-6 d-flex align-items-center justify-content-start gap-3 py-3">
              <img src="assets/icons/confermato.svg" [ngClass]="{'disabled': cartData.order.status_tracking < 0 && cartData.order.cc == 0}">
              Confermato
            </div>
            <div class="col-md-3 col-6 d-flex align-items-center justify-content-start gap-3 py-3">
              <img src="assets/icons/in-preparazione.svg" [ngClass]="{'disabled': cartData.order.status_tracking < 1 && cartData.order.cc == 0}">
              In preparazione
            </div>
            <div class="col-md-3 col-6 d-flex align-items-center justify-content-start gap-3 py-3" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
              <img src="assets/icons/pronto-per-ritiro.svg" [ngClass]="{'disabled': cartData.order.status_tracking < 2 && cartData.order.cc == 0}">
              Pronto per il ritiro
            </div>
            <div class="col-md-3 col-6 d-flex align-items-center justify-content-start gap-3 py-3" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
              <img src="assets/icons/ritirato.svg" [ngClass]="{'disabled': cartData.order.status_tracking < 3 && cartData.order.cc == 0}">
              Ritirato
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section class="section-b-space tracking-section multi-track pt-0 mb-5" *ngIf="cartData.order.ismultiorder">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-12" *ngIf="cartData.order.items && (cartData.order.items | array).length > 0">
          <div class="card">
            <div class="card-body" [ngStyle]="{'background-image': 'url('+ appInfo.ASSETS_URL + cartData.order.rest_mediaheader.filename + ')'}"></div>
          </div>
          <h5 class="my-3">Ordine da {{cartData.order.restaurant}}</h5>
          <button class="mega-button d-block d-md-none" (click)="trackOrder(-2)" *ngIf="orderCompleted()">
            Monitora il tuo ordine
            <img src="assets/icons/freccia.svg">
          </button>
          <div class="collection-collapse-block" [class.open]="collapseMultiMaster">
            <div class="collection-collapse-block-content">
              <div class="row tracking-row" >
                <div class="col-6 d-flex align-items-center justify-content-start gap-3 py-3">
                  <img src="assets/icons/confermato.svg" [ngClass]="{'disabled': cartData.order.status_tracking < 0 && cartData.order.cc == 0}">
                  Confermato
                </div>
                <div class="col-6 d-flex align-items-center justify-content-start gap-3 py-3">
                  <img src="assets/icons/in-preparazione.svg" [ngClass]="{'disabled': cartData.order.status_tracking < 1 && cartData.order.cc == 0}">
                  In preparazione
                </div>
                <div class="col-6 d-flex align-items-center justify-content-start gap-3 py-3" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
                  <img src="assets/icons/pronto-per-ritiro.svg" [ngClass]="{'disabled': cartData.order.status_tracking < 2 && cartData.order.cc == 0}">
                  Pronto per il ritiro
                </div>
                <div class="col-6 d-flex align-items-center justify-content-start gap-3 py-3" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
                  <img src="assets/icons/ritirato.svg" [ngClass]="{'disabled': cartData.order.status_tracking < 3 && cartData.order.cc == 0}">
                  Ritirato
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngFor="let slave of cartData.order.slaves; let i = index">
          <div class="col-lg-4 col-md-6 col-12" *ngIf="slave.items && (slave.items | array).length > 0">
            <div class="card">
              <div class="card-body" [ngStyle]="{'background-image': 'url('+ appInfo.ASSETS_URL + slave.rest_mediaheader.filename + ')'}"></div>
            </div>
            <h5 class="my-3">Ordine da {{slave.rest_name}}</h5>
            <button class="mega-button d-block d-md-none" (click)="trackOrder(i)" *ngIf="orderCompleted()">
              Monitora il tuo ordine
              <img src="assets/icons/freccia.svg">
            </button>
            <div class="collection-collapse-block" [class.open]="collapseMultiSlaves[i]">
              <div class="collection-collapse-block-content">
                <div class="row tracking-row">
                  <div class="col-6 d-flex align-items-center justify-content-start gap-3 py-3">
                    <img src="assets/icons/confermato.svg" [ngClass]="{'disabled': slave.status_tracking < 0 && slave.cc == 0}">
                    Confermato
                  </div>
                  <div class="col-6 d-flex align-items-center justify-content-start gap-3 py-3">
                    <img src="assets/icons/in-preparazione.svg" [ngClass]="{'disabled': slave.status_tracking < 1 && slave.cc == 0}">
                    In preparazione
                  </div>
                  <div class="col-6 d-flex align-items-center justify-content-start gap-3 py-3" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
                    <img src="assets/icons/pronto-per-ritiro.svg" [ngClass]="{'disabled': slave.status_tracking < 2 && slave.cc == 0}">
                    Pronto per il ritiro
                  </div>
                  <div class="col-6 d-flex align-items-center justify-content-start gap-3 py-3" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
                    <img src="assets/icons/ritirato.svg" [ngClass]="{'disabled': slave.status_tracking < 3 && slave.cc == 0}">
                    Ritirato
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </section>

  <section class="section-b-space suggestion-section pt-0 mb-5">
    <div class="container">
      <h5 class="my-4">Per il tuo prossimo ordine, prova anche gli altri ristoranti</h5>
      <div id="mix-items" #mixScroll class="promo-banner">                  
        <a [routerLink]="['/ristoranti/', rec.slug]" class="promo-container" *ngFor="let rec of suggestions" (click)="goToRestaurant(rec)">
          <div class="card">
            <div class="card-body" [ngStyle]="{'background-image': 'url('+ appInfo.ASSETS_URL + rec.mediaheader.filename + ')'}"></div>
          </div>
          <h5 class="pl-2">{{rec.name}}</h5>
        </a>         
      </div>
    </div>
  </section>
</ng-container>



<app-footer-two [class]="'bg-img-gym bg-size mt-0'"></app-footer-two>